import { useState } from "react";
import {
    Bar,
    BarChart,
    Cell,
    LabelList,
    Line,
    LineChart,
    Pie,
    PieChart,
    ResponsiveContainer,
    Tooltip,
    XAxis, YAxis
} from 'recharts';
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import { Autoplay, Navigation } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
import bookingSvg from "../../Assets/Images/cash-svgrepo-com.png";
import runsheetSvg from "../../Assets/Images/delivery-truck-automobile-svgrepo-com.png";
import manifestSvg from "../../Assets/Images/delivery-truck-truck-svgrepo-com.png";
import statusSvg from "../../Assets/Images/online-shop-shipping-and-delivery-svgrepo-com.png";
import percentage from "../../Assets/Images/percentage-percent-svgrepo-com.png";
import inscanSvg from "../../Assets/Images/scan-barcode-svgrepo-com.png";
import deliverySvg from "../../Assets/Images/tablet-ipad-svgrepo-com.png";
import Footer from "../Footer";
import { useDashboard } from "../Header/DashboardContext";
import Header from "../Header/Header";
import Sidebar1 from "../Sidebar1";
import './dashboard.css';

// Colors for Pie slices
const login = JSON.parse(localStorage.getItem("Login"));
const scanCard=[
    login?.GooglePayScanner1,
    login?.GooglePayScanner2,
    login?.GooglePayScanner2
]
const data1 = [
    {
        name: 'Jan',
        uv: 200,
        pv: 2500,
        amt: 4100,
    },
    {
        name: 'Feb',
        uv: 1000,
        pv: 3398,
        amt: 2210,
    },
    {
        name: 'March',
        uv: 2000,
        pv: 5800,
        amt: 2290,
    },
    {
        name: 'April',
        uv: 780,
        pv: 5908,
        amt: 2000,
    },
    {
        name: 'May',
        uv: 890,
        pv: 3800,
        amt: 2181,
    },
    {
        name: 'June',
        uv: 2390,
        pv: 1800,
        amt: 2500,
    },
    {
        name: 'July',
        uv: 3490,
        pv: 4300,
        amt: 2100,
    },
];

const data2 = [
    { name: "Group A", value: 400 },
    { name: "Group B", value: 300 },
    { name: "Group C", value: 300 },
    { name: "Group D", value: 200 }
];

const data3 = [
    {
        name: 'Jan',
        uv: 4000,
        pv: 2400,
        amt: 2400,
    },
    {
        name: 'Feb',
        uv: 3000,
        pv: 1398,
        amt: 2210,
    },
    {
        name: 'March',
        uv: 2000,
        pv: 9800,
        amt: 2290,
    },
    {
        name: 'April',
        uv: 2780,
        pv: 3908,
        amt: 2000,
    },
    {
        name: 'May',
        uv: 1890,
        pv: 4800,
        amt: 2181,
    },
    {
        name: 'June',
        uv: 2390,
        pv: 3800,
        amt: 2500,
    },
    {
        name: 'July',
        uv: 3490,
        pv: 4300,
        amt: 2100,
    },
    {
        name: 'Aug',
        uv: 3490,
        pv: 4300,
        amt: 2100,
    },
    {
        name: 'Sep',
        uv: 3490,
        pv: 4300,
        amt: 2100,
    },
];



function Dashboard() {

    const [tooltipPosition, setTooltipPosition] = useState({ x: 0, y: 0 });
    const handleMouseMove = (e) => {
        setTooltipPosition({ x: e.clientX, y: e.clientY });
    };

    const [isOpen, setIsOpen] = useState(false);

    const toggleDropdown = () => {
        setIsOpen(!isOpen);
    };
    const { dashboardData } = useDashboard();
    console.log(dashboardData);

    const bk = dashboardData?.booking[0] || {};
    const mf = dashboardData?.manifest || {};
    const ins = dashboardData?.inscon || {};
    const rs = dashboardData?.runsheet || {};
    const COLORS = ["#0088FE", "#00C49F", "#FFBB28", "#FF8042"];
    const COLORS1 = ["#FFA500", "#000000"];
    const COLORS2 = ["#007BFF", "red"];
    const cards = [
        { id: 1, title: "Booking", pending: bk.BookingPending || "0", done: bk.Delivered || "0", image: bookingSvg, total: bk.TotalCount },
        { id: 2, title: "Manifest", pending: mf.PendingManifest || "0", done: mf.ManifestDone || "0", image: manifestSvg, total: mf.TotalCount },
        { id: 3, title: "Inscan", pending: ins.InsconPending || "0", done: ins.InscondDone || "0", image: inscanSvg, total: ins.TotalCount },
        { id: 4, title: "Runsheet", pending: rs.PendingRunsheet || "0", done: rs.RunsheetDone || "0", image: runsheetSvg, total: rs.TotalCount },
        { id: 5, title: "Status Activity", pending: "10", done: "50", image: statusSvg, total: 0 },
        { id: 6, title: "Delivery Updation", pending: "20", done: "25", image: deliverySvg, total: 0 },
    ];
    console.log(cards);



    return (
        <>
            <Header />
            <Sidebar1 />
            <div className="main-body" id="main-body">
                <div className="dashboard-container">
                    <Swiper
                        modules={[Navigation, Autoplay]}
                        slidesPerView={4}
                        spaceBetween={20}
                        autoplay={{ delay: 4000 }}
                        speed={1300}
                        loop={true}
                        className="w-100"
                        style={{ marginTop: "20px" }}
                        breakpoints={{
                            320: { slidesPerView: 1 },
                            640: { slidesPerView: 2 },
                            1024: { slidesPerView: 3 },
                            1280: { slidesPerView: 4 },
                        }}
                    >
                        {cards.map((card) => {
                            const pending = parseInt(card.pending);
                            const done = parseInt(card.done);
                            const total = parseInt(card.total)

                            const data = [
                                { name: "Pending", value: pending },
                                { name: "Done", value: done },
                            ];

                            return (
                                <SwiperSlide key={card.id}>
                                    <div
                                        style={{
                                            background: "#fff",
                                            borderRadius: "15px",
                                            boxShadow: "0 3px 8px rgba(0,0,0,0.1)",
                                            padding: "10px",
                                            minHeight: "170px",
                                            minWidth: "220px",
                                            margin: "auto",
                                            display: "flex",
                                            flexDirection: "column", // title top, rest bottom
                                            alignItems: "center",
                                        }}
                                    >
                                        {/* Title top */}
                                        <div
                                            style={{
                                                width: "100%",
                                                marginBottom: "10px",
                                                fontSize: "18px",
                                                fontWeight: "600",
                                                textAlign: "center",
                                            }}
                                        >
                                            {card.title}
                                        </div>

                                        {/* Bottom row (Pie left + Right content) */}
                                        <div
                                            style={{
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "center",
                                                width: "100%",
                                                paddingLeft: "5px",
                                            }}
                                        >
                                            {/* Left (Pie) */}
                                            <div
                                                style={{
                                                    position: "relative",
                                                    width: "120px",
                                                    height: "120px",
                                                    flexShrink: 0,
                                                }}
                                            >
                                                <PieChart width={120} height={120}>
                                                    <Pie
                                                        data={data}
                                                        cx="50%"
                                                        cy="50%"
                                                        innerRadius={45}   // 🔹 बड़ा innerRadius = पतला circle
                                                        outerRadius={55}   // 🔹 outerRadius थोड़ा ज़्यादा = thin ring look
                                                        paddingAngle={2}
                                                        dataKey="value"
                                                    >
                                                        {data.map((entry, index) => (
                                                            <Cell
                                                                key={`cell-${index}`}
                                                                fill={
                                                                    card.id % 2 === 0
                                                                        ? COLORS2[index % COLORS2.length]   // Even cards → Blue/Black
                                                                        : COLORS1[index % COLORS1.length]   // Odd cards → Orange/Black
                                                                }
                                                                stroke="#fff"
                                                                strokeWidth={0.5}
                                                            />
                                                        ))}
                                                    </Pie>
                                                </PieChart>

                                                {/* Center total */}
                                                <div
                                                    style={{
                                                        position: "absolute",
                                                        top: "50%",
                                                        left: "50%",
                                                        transform: "translate(-50%, -50%)",
                                                        textAlign: "center",
                                                    }}
                                                >
                                                    <h4 style={{ margin: 0, fontSize: "14px", fontWeight: "bold" }}>{total}</h4>
                                                    <small style={{ fontSize: "11px", fontWeight: "bold" }}>Total</small>
                                                </div>
                                            </div>

                                            {/* Right (Image + Pending/Done) */}
                                            <div
                                                style={{
                                                    flex: 1,
                                                    marginLeft: "15px",
                                                    display: "flex",
                                                    flexDirection: "column",
                                                    alignItems: "center",
                                                }}
                                            >
                                                {/* Image */}
                                                <img
                                                    src={card.image}
                                                    alt={card.title}
                                                    style={{ width: "45px", height: "45px", marginBottom: "8px" }}
                                                />

                                                {/* Pending + Done side-by-side */}
                                                <div
                                                    style={{
                                                        display: "flex",
                                                        justifyContent: "space-between",
                                                        width: "100%",
                                                    }}
                                                >
                                                    {/* Pending */}
                                                    <div style={{ textAlign: "center", flex: 1 }}>
                                                        <span
                                                            style={{
                                                                color: card.id % 2 === 0 ? "#007BFF" : "#FFA500", // even → blue, odd → orange
                                                                fontWeight: "bold",
                                                                fontSize: "14px",
                                                            }}
                                                        >
                                                            {pending}
                                                        </span>
                                                        <p style={{ margin: 0, fontSize: "12px" }}>Pending</p>
                                                    </div>

                                                    {/* Done */}
                                                    <div style={{ textAlign: "center", flex: 1 }}>
                                                        <span
                                                            style={{
                                                                color: card.id % 2 === 0 ? "red" : "#000000", // black for all
                                                                fontWeight: "bold",
                                                                fontSize: "14px",
                                                            }}
                                                        >
                                                            {done}
                                                        </span>
                                                        <p style={{ margin: 0, fontSize: "12px" }}>Done</p>
                                                    </div>

                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </SwiperSlide>
                            );
                        })}
                    </Swiper>





                    <div style={{ display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "center", marginTop: "20px" }}>
                        <div className="card" style={{ width: "70%", marginRight: "10px", height: "350px", padding: "20px", border: "none" }}>
                            <div className="column1">
                                <div className="row1" style={{ justifyContent: "space-between" }}>
                                    <b style={{ marginBottom: "70px" }}>Statistic</b>
                                    <div className="dropdown">
                                        <button onClick={toggleDropdown} className="ok-btn" style={{ height: "30px", width: "130px" }}>
                                            Select Option ▼
                                        </button>

                                        {isOpen && (
                                            <ul className="dropdown-menu" style={{ paddingLeft: "5px" }}>
                                                <li>This Month</li>
                                                <li>This Week</li>
                                                <li>Today</li>
                                            </ul>
                                        )}
                                    </div>
                                </div>
                                <div>
                                    <ResponsiveContainer width={"100%"} height={200}>
                                        <LineChart data={data1} margin={{ top: 20 }}>
                                            <XAxis dataKey="name" padding={{ left: 30, right: 30 }}
                                                tick={{ fill: "#aaa", fontSize: 12 }} />
                                            <YAxis tick={{ fill: "#aaa", fontSize: 12 }} />
                                            <Tooltip />
                                            <Line
                                                type="monotone"
                                                dataKey="pv"
                                                stroke="purple"
                                            >
                                                <LabelList position="top" offset={200} />
                                            </Line>
                                            <Line type="monotone" dataKey="uv" fill="#0088FE">
                                                <LabelList position="top" offset={200} />
                                            </Line>
                                        </LineChart>
                                    </ResponsiveContainer>
                                </div>
                            </div>
                        </div>

                        <div className="card" style={{ width: "30%", marginLeft: "10px", height: "350px", border: "none" }}>
                            <b>Data</b>
                            <div>
                                <ResponsiveContainer width={"100%"} height={200}>
                                    <PieChart>
                                        <Pie
                                            data={data2}
                                            cx={140}
                                            cy={90}
                                            innerRadius={60}
                                            outerRadius={80}
                                            fill="#8884d8"
                                            paddingAngle={5}
                                            dataKey="value"
                                        >
                                            {data2.map((entry, index) => (
                                                <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
                                            ))}
                                        </Pie>
                                    </PieChart>
                                </ResponsiveContainer>
                            </div>
                            <b>Data</b>
                            <div className="row1" style={{ justifyContent: "space-between" }}>
                                <div style={{ display: "flex", flexDirection: "row" }}>
                                    <div className="box" style={{ height: "15px", width: "15px", borderRadius: "5px", backgroundColor: "#0088FE", margin: "5px" }}></div>
                                    <p style={{ margin: "0px", padding: "0px" }}>Primary (27%)</p>
                                </div>
                                <b>763</b>
                            </div>

                            <div className="row1" style={{ justifyContent: "space-between" }}>
                                <div style={{ display: "flex", flexDirection: "row" }}>
                                    <div className="box" style={{ height: "15px", width: "15px", borderRadius: "5px", backgroundColor: "#00C49F", margin: "5px" }}></div>
                                    <p style={{ margin: "0px", padding: "0px" }}>Promotion (11%)</p>
                                </div>
                                <b>321</b>
                            </div>

                            <div className="row1" style={{ justifyContent: "space-between" }}>
                                <div style={{ display: "flex", flexDirection: "row" }}>
                                    <div className="box" style={{ height: "15px", width: "15px", borderRadius: "5px", backgroundColor: "#FFBB28", margin: "5px" }}></div>
                                    <p style={{ margin: "0px", padding: "0px" }}>Forum (22%)</p>
                                </div>
                                <b>154</b>
                            </div>
                        </div>
                    </div>

                    <div className="card" style={{ height: "420px", width: "100%", backgroundColor: "#01A3FF", color: "white", border: "none", marginTop: "30px" }}>
                        <div className="row1" style={{ height: "100%", width: "100%" }}>
                            <div className="column1" style={{ height: "100%", width: "75%" }}>
                                <b style={{ marginBottom: "20px", marginLeft: "10px", marginTop: "10px" }}>Statistic</b>

                                <ResponsiveContainer width="100%" height="100%">
                                    <BarChart
                                        data={data3}
                                        margin={{
                                            top: 5,
                                            right: 30,
                                            left: 20,
                                            bottom: 5,
                                        }}
                                        barSize={7}

                                    >
                                        <XAxis dataKey="name" tick={{ fill: "#fff" }} />
                                        <YAxis tick={{ fill: "#fff" }} />
                                        <Tooltip />
                                        <Bar dataKey="uv" fill="white" radius={[15, 15, 10, 10]} />
                                        <Bar dataKey="pv" fill="yellow" radius={[15, 15, 10, 10]} />
                                    </BarChart>
                                </ResponsiveContainer>
                            </div>

                            <div className="column1" style={{ height: "100%", width: "25%", padding: "10px" }}>
                                <div className="dropdown">
                                    <button onClick={toggleDropdown} className="ok-btn" style={{ height: "30px", width: "130px" }}>
                                        Select Option ▼
                                    </button>

                                    {isOpen && (
                                        <ul className="dropdown-menu" style={{ paddingLeft: "5px" }}>
                                            <li>This Month</li>
                                            <li>This Week</li>
                                            <li>Today</li>
                                        </ul>
                                    )}
                                </div>

                                <div className="row1" style={{ marginTop: "15px", justifyContent: "space-between" }}>
                                    <div className="row1">
                                        <input type="radio" name="" id="" style={{ display: "block", width: "20px" }} />
                                        <div className="column1" style={{ marginLeft: "10px" }}>
                                            <p style={{ color: "white", margin: "0px", padding: "0px" }}>Pending</p>
                                            <b>1982</b>
                                        </div>
                                    </div>

                                    <div className="row1">
                                        <input type="radio" name="" id="" style={{ display: "block", width: "20px" }} />
                                        <div className="column1" style={{ marginLeft: "10px" }}>
                                            <p style={{ color: "white", margin: "0px", padding: "0px" }}>Done</p>
                                            <b>1982</b>
                                        </div>
                                    </div>
                                </div>

                                <div className="card" style={{
                                    height: "120px", marginTop: "20px", color: "white",
                                    backgroundColor: "#36aef3", border: "none", paddingLeft: "20px"
                                }}>
                                    <p style={{ margin: "0px", padding: "0px", color: "white" }}>Pending</p>
                                    <b style={{ fontSize: "18px" }}>$ 12,890,00</b>
                                    <div className="row1" style={{ marginTop: "5px" }}>
                                        <i className="bi bi-arrow-up-circle-fill" style={{ fontSize: "22px", marginRight: "5px" }}></i>
                                        <b>+15 %</b>
                                    </div>
                                </div>

                                <div className="card" style={{
                                    height: "120px", marginTop: "20px", color: "white",
                                    backgroundColor: "#36aef3", border: "none", paddingLeft: "20px"
                                }}>
                                    <p style={{ margin: "0px", padding: "0px", color: "white" }}>Done</p>
                                    <b style={{ fontSize: "18px" }}>$ 12,890,00</b>
                                    <div className="row1" style={{ marginTop: "5px" }}>
                                        <i className="bi bi-arrow-down-circle-fill" style={{ fontSize: "22px", marginRight: "5px" }}></i>
                                        <b>+15 %</b>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="scan-card-wrapper">
  {scanCard.map((item, index) => (
    <div className="scan-card" key={index}>
      <img src={item} alt={`scan-${index}`} />
    </div>
  ))}
</div>

                   



                </div>
                <Footer />
            </div>
        </>
    )
}


export default Dashboard;